import { Message } from 'element-ui'
import { Utils } from './utils'
/**
 * 判断数据是否为 null、undefined、""
 * data:验证数据
 * **/
export function isNull(data) {
    return (data === null || data === '' || data === undefined || data === 'null' || data === 'undefined');
}

/**
 * 判断验证数据是否为function
 * obj：验证数据
 * **/
export function isFuntion(obj) {
    return (obj && (typeof obj == 'function'));
}

/**
 * 判断数据是否是字符串
 * obj:验证数据
 * **/
export function isString(obj) {
    return (obj && (typeof obj == "string"));
}

/**
 * 判断验证数据是否为空对象
 * obj:验证对象
 * **/
export function isNullObj(obj) {
    for (var i in obj)
        if (obj.hasOwnProperty(i))
            return false;
    return true;
}

/**
 * 判断数据是否为数据
 * obj：验证对象
 * **/
export function isArray(obj) {
    return (Object.prototype.toString.call(obj) === "[object Array]");
}

/**
 * 判断是否书否为对象
 * obj：验证对象
 * **/
export function isObject(obj) {
    return (obj && typeof obj === 'object');
}

/**
 * 判断验证对象是否为空数组
 * obj:验证对象
 * **/
export function isEmptyArray(obj) {
    return (isArray(obj) && obj.length == 0);
}

/**
 * 判断验证对象是否为数字
 * value:验证对象
 * **/
export function isNumber(value) {
    return /(0|^[1-9]\d*$)/.test(value);
}

/**
 * 计算字符串为多少个汉字
 * str:验证子u穿
 * **/
export function getLength(str) {
    var i, len, code;
    if (isNull(str)) return 0;
    len = str.length;
    for (i = 0; i < str.length; i++) {
        code = str.charCodeAt(i);
        if (code > 255)
            len++;
    }
    return len;
}

/**
 * 获取对象的长度
 * obj：验证对象
 * 返回对象长度
 * **/
export function getObjLength(obj) {
    var objLen = 0;
    for (var i in obj)
        objLen++;
    return objLen;
}

/**
 * 正则验证某个字符串是否符合某种验证规则
 * regExp:验证规则
 * str:需要验证的字符串
 * **/
export function checkReg(regExp, str) {
    return regExp.exec(str);
}

/**
 * 输入框的长度限制
 * 当超出长度切断并返回
 * **/
export function inputMaxLength(value, length) {
    var len = isNull(length) ? 5 : length;
    if (value.length > len) return value.slice(0, len);
}

/**
 * 时间格式化
 * 返回转换之后的字符串
 * **/
export function format(format) {
    var dateObj = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format))
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in dateObj)
        if (new RegExp("(" + k + ")").test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? dateObj[k] : ("00" + dateObj[k]).substr(("" + dateObj[k]).length));
    return format;
}

/**
 * 获取元素高宽距离等信息
 * targetClass:目标元素class
 * **/
export function getDomInfo(_vue, targetClass) {
    return new Promise((reslove) => {
        uni.createSelectorQuery().in(_vue).select(targetClass).boundingClientRect(function(data) {
            reslove(data);
        }).exec(function(res) {})
    })
}

/**
 * restful接口路径拼接
 * url:请求地址
 * params：请求参数
 * sortList:请求参数排序 元素为请求参数的key
 * **/
export function getUrlParams(url, params, sortList) {
    let str = "";
    if (!isNull(sortList) && isArray(sortList))
        sortList.map(item => {
            str = isNull(str) ? `/${params[item]}` : `${str}/${params[item]}`;
        });
    return `${url}${str}`;
}


/**
 * 计算倒计时
 * timer：时间值 秒
 * flag分隔方式：true 文字分隔；false：冒号分隔
 * type:字符串返回格式 0:包含天 1：时分秒 2：时分
 * 返回 {
 *     time:下一次倒计时使用的值
 *     str：当前倒计时的字符串
 * }
 * **/
export function countdownTime(timer, type = 0, flag) {
    var dayText, hourText, minuteText, secondText;
    if (flag) {
        dayText = "天";
        hourText = "小时";
        minuteText = "分";
        secondText = "秒";
    } else {
        dayText = ":";
        hourText = ":";
        minuteText = ":";
        secondText = "";
    }
    var day = 0,
        hour = 0,
        minute = 0,
        second = 0; //时间默认值
    if (timer > 0) {
        day = Math.floor(timer / (60 * 60 * 24));
        hour = Math.floor(timer / (60 * 60)) - (day * 24);
        minute = Math.floor(timer / 60) - (day * 24 * 60) - (hour * 60);
        second = Math.floor(timer) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    }
    if (hour <= 9) hour = '0' + hour;
    if (minute <= 9) minute = '0' + minute;
    if (second <= 9) second = '0' + second;
    var str = "";
    switch (type) {
        case 0:
            str = "" + day + dayText + hour + hourText + minute + minuteText + second + secondText;
            break;
        case 1:
            str = "" + hour + hourText + minute + minuteText + second + secondText;
            break;
        case 2:
            str = "" + hour + hourText + minute;
    }
    timer--;
    return {
        time: timer,
        str: str,
        day,
        hour,
        minute,
        second
    }
}

/**
 * 聊天時間處理
 * time:時間毫秒值
 * 返回：当时间小于当天凌晨返回年月日时分秒全部时间，否则返回当天是时分秒
 * **/
export function dealChatTime(time) {
    if (isNull(time)) return;
    let currentDate = new Date();
    let currendTimeZero = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime();
    let diffTime = time - currendTimeZero;
    let date = new Date(time);
    let hourMinSec = `${fillNum(date.getHours())}:${fillNum(date.getMinutes())}:${fillNum(date.getSeconds())}`;
    if (diffTime <= 0) {
        return `${date.getFullYear()}-${fillNum(date.getMonth() + 1)}-${fillNum(date.getDate())} ${hourMinSec}`;
    }
    return hourMinSec;
}

/**
 * 时间转换 当大于等于10 原数据返回 否则在前面＋0
 * num:判定的数据
 * **/
export function fillNum(num) {
    if (num >= 10) {
        return num;
    }
    return `0${num}`;
}

/**
 * @desc 函数防抖---“立即执行版本” 和 “非立即执行版本” 的组合版本
 * @param func 需要执行的函数
 * @param wait 延迟执行时间（毫秒）
 * @param immediate---true 表立即执行，false 表非立即执行
 **/
export function debounce(fn, wait, immediate = false) {
    let timer;
    return function() {
        if (timer) clearTimeout(timer);
        if (immediate) {
            // 如果已经执行过，不再执行
            var callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, wait)
            if (callNow) {
                fn.apply(this, arguments)
            }
        } else {
            timer = setTimeout(() => {
                fn.apply(this, arguments)
            }, wait);
        }
    }
}
export function tryCatchFn(fn) {
    return function() {
        try {
            fn.apply(this, arguments)
        } catch (error) {
            console.log(111111);
        }
    }
}

/**
 * 字典获取文字
 * value 字典值  list 字典list
 * */
export function dictGetText(value, list) {
    for (let i = 0; i < list.length; i++) {
        if (list[i].value === value) {
            return list[i].label
        }
    }
    return value
}

/* 请求参数拼接
 * url:地址路径
 * querys:对象
 * **/
export function urlQuery(url, querys) {
    let keys = Object.keys(querys);
    let path = "";
    keys.map(key => {
        path = isNull(path) ? `${url}?${key}=${querys[key]}` : `${path}&${key}=${querys[key]}`;
    });
    return path;
}

/**
 * 列表中倒计时计算
 * that:小程序实例
 * arr：需要计算的列表
 * timerList:定时器id列表
 * fieldName：倒计时字段名
 * listName:列表字段名
 * **/
export function computedListCutdownTime(that, arr, timerList, listName, fieldName) {
    let list = [...arr];
    let timerArr = [];
    timerArr.map(item => { //清空定时器
        clearInterval(item);
    });
    list.map((item, index) => {
        let cutDownTime = Math.ceil(Number(list[index][fieldName]));
        if (cutDownTime <= 0) return;
        let timer = setInterval(() => {
            // console.log(that.data[listName]);
            if (isNull(that.data[listName]) || isEmptyArray(that.data[listName])) {
                list = [];
                timerArr.map(item => { //清空定时器
                    clearInterval(item);
                });
                that.setData({
                    [listName]: []
                });
                return;
            }
            if (cutDownTime <= 0) {
                return clearInterval(timer);
            }
            let _index = timerArr.findIndex(_item => {
                return _item === timer;
            });
            if (_index === -1) {
                timerArr.push(timer);
            }
            cutDownTime--;
            let opt = countdownTime(cutDownTime, 1, true);
            if (isEmptyArray(list)) return
            list[index][`${fieldName}Str`] = opt.str;
            list[index][fieldName] = opt.time;
            that.setData({
                [listName]: list
            })
        }, 1000);
    })
}

/**
 * 时间倒计时
 * that:小程序实例
 * timeNum:时间秒
 * timer：清空时间的对象
 * fieldName:字段名
 * **/
export function timeCutDown(that, timeNum, timer, fieldName) {
    if (isNull(timer)) {
        clearInterval(timer)
    }
    let cutDownTime = Math.ceil(Number(timeNum));
    if (cutDownTime <= 0) return;
    let _timer = setInterval(() => {
        if (cutDownTime <= 0) {
            return clearInterval(_timer);
        }
        cutDownTime--;
        let opt = countdownTime(cutDownTime, 1, true);
        that.setData({
            [fieldName]: opt.time,
            [`${fieldName}Str`]: opt.str,
            timer: _timer
        })
    }, 1000);

}

/**
 * 数据存储sessionStorage中
 * key:sessionStorage的key
 * value：需要存入的值
 * **/
export function setSessionStorage(key, value) {
    let str = value;
    if (isArray(str) || isObject(str)) {
        str = JSON.stringify(str);
    }
    sessionStorage.setItem(key, str);
}

/**
 * 获取sessionStorage的值
 * key：sessionStorage值得key
 * **/
export function getSessionStorage(key) {
    return sessionStorage.getItem(key);
}

/**
 * 删除sessionStorage
 * key：需要删除的key
 * **/
export function deleteSessionStorage(key) {
    return sessionStorage.removeItem(key);
}

/**
 * 清空sessionStorage
 * **/
export function clearSessionStorage() {
    return sessionStorage.clear();
}

/**
 * loading动画
 * _vue:实例
 * config:配置参数
 * 返回关闭的方法
 * **/
export function loading(_vue, config) {
    let options = {
        lock: true,
        text: config.text || "加载中",
        spinner: "el-icon-loading",
    };
    return _vue.$loading(options);
}

/**
 * message success
 * _vue:vue实例
 * text:提示文字
 * config其他参数配置
 * **/
export function messageSuccess(_vue, text, config = {}) {
    let options = {
        type: "success",
        message: text,
        ...config
    };
    _vue.$message(options);
}

/**
 * message warning
 * _vue:vue实例
 * text:提示文字
 * config其他参数配置
 * **/
export function messageWarning(_vue, text, config = {}) {
    let options = {
        type: "warning",
        message: text,
        ...config
    };
    _vue.$message(options);
}

/**
 * message error
 * _vue:vue实例
 * text:提示文字
 * config其他参数配置
 * **/
export function messageError(_vue, text, config = {}) {
    let options = {
        type: "error",
        message: text,
        ...config
    };
    _vue.$message(options);
}

/**
 * message Info
 * _vue:vue实例
 * text:提示文字
 * config其他参数配置
 * **/
export function messageInfo(_vue, text, config = {}) {
    let options = {
        type: "info",
        message: text,
        ...config
    };
    _vue.$message(options);
}

/**
 * notice success
 * _vue:vue实例
 * message：消息体
 * config：配置
 * **/
export function noticeSuccess(_vue, message, config = {}) {
    let option = {
        type: "success",
        message: message,
        ...config
    };
    return _vue.$notify(option);
}

/**
 * notice error
 * _vue:vue实例
 * message：消息体
 * config：配置
 * **/
export function noticeError(_vue, message, config = {}) {
    let option = {
        type: "error",
        message: message,
        ...config
    };
    return _vue.$notify(option);
}

/**
 * notice wraning
 * _vue:vue实例
 * message：消息体
 * config：配置
 * **/
export function noticeWarning(_vue, message, config = {}) {
    let option = {
        type: "warning",
        message: message,
        ...config
    };
    return _vue.$notify(option);
}

/**
 * notice info
 * _vue:vue实例
 * message：消息体
 * config：配置
 * **/
export function noticeInfo(_vue, message, config = {}) {
    let option = {
        type: "info",
        message: message,
        ...config
    };
    return _vue.$notify(option);
}

/**
 * 拼接疾病名称
 * @param {*} illnessJson
 * @returns
 */
export function getIllnessNameStr(illnessJson) {
    let jsonArray = JSON.parse(illnessJson);
    if (!jsonArray || jsonArray.length < 1) return "";
    let illnessName = "";
    for (let item1 of jsonArray) {
        illnessName += item1.name + ",";
    }
    return illnessName.substr(0, illnessName.length - 1);
}

/**
 * 获取字典值转换
 *  type 字典类型
 *  val 需要装换的值
 *
 */
export function dictText(val, arrList) {
    let list = arrList;
    if (isNull(list) || !isArray(list) || isEmptyArray(list)) {
        return val
    }
    for (let i = 0; i < list.length; i++) {
        if (list[i].value == val) {
            return list[i].label
        }
    }
    return val
}

/**
 * 获取字典
 * type:字典的类型
 */
export function getDic(type) {
    let dicOption; //字典对象
    let dicList = store.state.user.dictionaryList;
    let dicSessionOptions = isNull(getSessionStorage("dictList")) ? {} : JSON.parse(getSessionStorage("dictionaryList"));
    dicOption = isNull(dicList) ? dicSessionOptions : dicList;
    let currentDicList = dicOption[type];
    if (isNull(currentDicList) || !isArray(currentDicList)) return [];
    return currentDicList;
}

/**
 * 高度计算
 * refsList 需要减去的dom 对象
 * height 总高度
 *
 */
export function heightCount(refsList, height) {
    let contentHeight = 0
    for (let i = 0; i < refsList.length; i++) {
        contentHeight += refsList[i].offsetHeight
    }
    return height - contentHeight
}

/**
 * 获取当前时间
 *
 */
export function getNowTime() {
    let dateTime
    let yy = new Date().getFullYear()
    let mm = new Date().getMonth() + 1
    let dd = new Date().getDate()
    let hh = new Date().getHours()
    let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() :
        new Date().getMinutes()
    let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() :
        new Date().getSeconds()
    dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    console.log(dateTime)
    return dateTime
}

/**
 * 清空本地储存处方
 * type 处方类型  add 新建处方 reopen 重开处方
 */
export function claerPrescriptionStorage(type) {
    deleteSessionStorage(
        `${type === "add" ? "new" : "reopen"}PrescriptionInfo`
    );
    deleteSessionStorage(
        `${type === "add" ? "new" : "reopen"}DiagnosePeopleInfo`
    );
    deleteSessionStorage(
        `${type === "add" ? "new" : "reopen"}PrescriptionId`
    );
    deleteSessionStorage(
        `${type === "add" ? "new" : "reopen"}DiagnoseId`
    );
}

/**
 * 消息确认框
 * vue:实例
 * options：配置参数
 * options:{
 *     title:标题
 *     message：消息体
 *     type:消息类型
 *     iconClass：自定义图标
 *     callback：不适用promise的回调函数
 *     showClose：是否显示右上角
 *     beforeClose：关闭前的回调
 *     showCancelButton：是否显示取消按钮
 *     showConfirmButton：是否显示确认按钮
 *     cancelButtonText：取消按钮文本
 *     confirmButtonText：确认按钮文本
 * }
 * **/
export function msgbox(_vue, options) {
    let params = {
        title: "提示",
        // type: "success",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
    };
    Object.assign(params, options);
    return _vue.$msgbox(params).then(res => {
        options.confirmFn();
    }).catch(err => {
        options.cancelFn()
    });
}

/**
 * 成功提示框
 * options:{
 *     title标题
 *     confirmFn：确认的回调函数
 *     cancelFn:取消的回调函数
 * }
 * **/
export function msgboxSuccess(_vue, options) {
    let params = {
        title: "提示",
        type: "success",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
    };
    Object.assign(params, options);
    return _vue.$msgbox(params).then(res => {
        options.confirmFn();
    }).catch(err => {
        options.cancelFn()
    });
}

/**
 * 消息提示框
 * options:{
 *     title标题
 *     confirmFn：确认的回调函数
 *     cancelFn:取消的回调函数
 * }
 * **/
export function msgboxInfo(_vue, options) {
    let params = {
        title: "提示",
        type: "info",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
    };
    Object.assign(params, options);
    return _vue.$msgbox(params).then(res => {
        options.confirmFn();
    }).catch(err => {
        options.cancelFn()
    });
}

/**
 * 警告提示框
 * options:{
 *     title标题
 *     confirmFn：确认的回调函数
 *     cancelFn:取消的回调函数
 * }
 * **/
export function msgboxWarning(_vue, options) {
    let params = {
        title: "提示",
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true
    };
    Object.assign(params, options);
    return _vue.$msgbox(params).then(res => {
        options.confirmFn();
    }).catch(err => {
        console.log(err)
        options.cancelFn()
    });
}

/**
 * 错误提示框
 * options:{
 *     title标题
 *     confirmFn：确认的回调函数
 *     cancelFn:取消的回调函数
 * }
 * **/
export function msgboxError(_vue, options) {
    let params = {
        title: "提示",
        type: "error",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
    };
    Object.assign(params, options);
    return _vue.$msgbox(params).then(res => {
        options.confirmFn();
    }).catch(err => {
        options.cancelFn()
    });
}

/**
 * 返回的菜单权限过滤
 * authMenuList:返回的菜单权限列表
 * sysMenuList：当前系统应有的菜单权限列表
 * **/
export function menuListFilter(authMenuList, sysMenuList) {
    console.log(authMenuList, sysMenuList);
    if (!isArray(authMenuList) || !isArray(sysMenuList) || isEmptyArray(authMenuList) || isEmptyArray(sysMenuList)) return [];
    let menu = [];
    authMenuList.map(item => {
        if (sysMenuList.includes(item.path)) {
            let list = JSON.parse(JSON.stringify(item));
            let children = list.children.filter(item => {
                return sysMenuList.includes(item.path);
            });
            list.children = children;
            menu.push(list);
        }
    });
    return menu;
}

/**
 * base64 转file
 * dataUrl base64数据
 * filename 文件名称
 * */
export function base64toFile(dataUrl, fileName = 'file') {
    let arr = dataUrl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${fileName}.${suffix}`, {
        type: mime
    })
}

/**
 * 数学数字转换成中文数字
 * **/
export function numberToString(number) {
    if (number.match(/\D/) || number.length >= 14) return;
    let zhArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']; // 数字对应中文
    let baseArray = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万']; //进位填充字符，第一位是 个位，可省略
    let string = String(number).split('').reverse().map((item, index) => { // 把数字切割成数组并倒序排列，然后进行遍历转成中文
        // 如果当前位为0，直接输出数字， 否则输出 数字 + 进位填充字符
        item = Number(item) == 0 ? zhArray[Number(item)] : zhArray[Number(item)] + baseArray[index];
        return item;
    }).reverse().join(''); // 倒叙回来数组，拼接成字符串
    string = string.replace(/^一十/, '十'); // 如果以 一十 开头，可省略一
    string = string.replace(/零+/, '零'); // 如果有多位相邻的零，只写一个即可
    return string;
}
/** * 获取性别信息
 * type:性别类型 0 ：未知 1：男 2：女
 * **/
export function genderFilter(type) {
    let dicList = getSessionStorage("dictList");
    if (isNull(dicList)) return "未知";
    let gender = JSON.parse(dicList).gender;
    let index = gender.findIndex(item => {
        return item.value === type;
    });
    if (isNull(gender[index])) return
    let label = gender[index].label;
    return isNull(label) ? "未知" : label;
}

/**
 * 保留小数
 * @param {string|number} value 数据
 * @param {number} fractionDigits 保留位数
 */

export const toFixed = (value, fractionDigits = 2) => {
    let num = Number(value);
    if (isNull(value) || Number.isNaN(num)) {
        return value;
    }
    let numbers = '';
    // 保留几位小数后面添加几个0
    for (let i = 0; i < fractionDigits; i++) {
        numbers += '0';
    }
    let s = 1 + numbers;
    // 如果是整数需要添加后面的0
    let spot = "." + numbers;
    // Math.round四舍五入
    //  parseFloat() 函数可解析一个字符串，并返回一个浮点数。
    num = Math.round(parseFloat(value) * s) / s;
    // 从小数点后面进行分割
    let d = num.toString().split(".");
    if (d.length == 1) {
        return num.toString() + spot;
    }
    if (d[1].length < 2) {
        num = num.toString() + "0";
    }
    return num;
};
/**
 * 对象深拷贝
 * data:被拷贝的对象
 */
export function deepClone(data) {
    var type = getObjType(data)
    var obj
    if (type === 'array') {
        obj = []
    } else if (type === 'object') {
        obj = {}
    } else {
        // 不再具有下一层次
        return data
    }
    if (type === 'array') {
        for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]))
        }
    } else if (type === 'object') {
        for (var key in data) {
            obj[key] = deepClone(data[key])
        }
    }
    return obj
}

/**
 * 获取对象类型
 * **/
export function getObjType(obj) {
    var toString = Object.prototype.toString
    var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    }
    if (obj instanceof Element) {
        return 'element'
    }
    return map[toString.call(obj)]
}

/**
 * 小数限制
 * val：值
 * isFloat:是否保存小数 true：小数 false整数
 * intNum:整数位数 默认4位
 * floatNum:小数位数 默认2位
 * **/
export function inputNumSlice(val, isFloat, intNumber = 4, floatNumber = 2) {
    let index = val.indexOf("."); //是否存在小数
    let intNum = intNumber;
    if (index === -1) { //没有小数
        return val.slice(0, intNum);
    }
    let arr = val.split(".");
    let arrInt = arr[0].length > intNum ? arr[0].slice(0, intNum) : arr[0];
    let arrFloat = arr[1].length > floatNumber ? arr[1].slice(0, floatNumber) : arr[1];
    if (!isFloat && index !== -1) { //不能输入小数
        return arrInt.slice(0, arrInt.length - 1);
    }
    return `${arrInt}.${arrFloat}`;
}

/**
 * @description: 通过url 下载文件
 * @param {*} url
 * @param {*} fileName
 * @param {*} flieId
 * @param {*} type
 * @return {*}
 */
export function downloadUrl(url) {
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * @description: 通过blob 对象 下载文件
 * @param {*}
 * @return {*}
 */
export function downFileBlob(data, type, fileName) {
    //
    let blob = new Blob([data], { type: `${type};charset=utf-8` });
    // 获取heads中的filename文件名
    let downloadElement = document.createElement('a');
    // 创建下载的链接
    let href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    // 下载后文件名
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    // 点击下载
    downloadElement.click();
    // 下载完成移除元素
    document.body.removeChild(downloadElement);
    // 释放掉blob对象
    window.URL.revokeObjectURL(href);

}
/**
 * @description: 验证文件流接口 返回文件是否正确
 * @param {*} data
 * @return {*}
 */
export async function blobErrorValidate(data) {
    try {
        const text = await data.text();
        return JSON.parse(text);
    } catch (error) {
        return null;
    }
}

/**
 * 数组去重
 * list 数组
 * key 根据哪个字段去重
 */
export function uniqueArray(list, key) {
    let newList = []
    list.forEach(function(a) {
        var check = newList.every(function(b) {
            return a[key] != b[key];
        })
        check ? newList.push(a) : ''
    })
    return newList;
}
/**
 * 验证正则
 * @param {*} value 
 * @param {*} reg 
 * @param {*} msg 
 * @returns 
 */
export function validParams(value, reg, msg) {
    let regExp = new RegExp(reg);
    let bol = true;
    if (!regExp.test(value)) {
        bol = false
        if (!_.isEmpty(msg)) {
            Message.warning(msg)
        }
    }
    return bol
}

/**
 * 计时器
 * name 计时器名称
 * fn 执行的方法
 * time时间
 */
export function intervalTimer(name, fn, time = 1000) {
    if (intervalTimer[name]) { // 判断定时器是否存在
        clearInterval(intervalTimer[name]) // 存在则清除
    }

    intervalTimer[name] = setInterval(() => { // 设置新的定时器
        fn() // 执行传入的函数
    }, time)
}

/**
 * 计时器
 * name 计时器名称
 * fn 执行的方法
 * time时间
 */
export function timeoutTimer(name, fn, time = 1000) {
    if (timeoutTimer[name]) { // 判断定时器是否存在
        clearTimeout(timeoutTimer[name]) // 存在则清除
    }
    timeoutTimer[name] = setTimeout(() => { // 设置新的定时器
        fn() // 执行传入的函数
    }, time)
}


/**
 * 判断两个日期是否大于某天
 * diffValue 差值
 * @returns 
 */
export function isMoreThanOneYear(date1, date2, diffValue) {
    // 将字符串转换为 Date 对象
    var d1 = new Date(date1);
    var d2 = new Date(date2);
    // 计算两个日期之间相差的天数
    var diffTime = Math.abs(d2 - d1);
    var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Utils.gt(diffDays, diffValue);
}

/**
 * 将key值相同的数据中某个值相加
 * @param {*} arr  需要处理的数组
 * @param {*} keyName key值
 * @param {*} valueName  通过哪一个值相加
 * @returns 
 */
export function delSomeObjValue(arr, keyName, valueName) {
    const idArr = [] // 相同的id放在同一数组中
    const resultArr = [] // 最终结果数组
    for (let i = 0; i < arr.length; i++) {
        const index = idArr.indexOf(arr[i][keyName])
        if (index > -1) { // 有相同id存在的话,获取index索引位置
            resultArr[index][valueName] = Utils.bigNumber(resultArr[index][valueName], '+', arr[i][valueName]) //取相同id的value累加
        } else {
            idArr.push(arr[i][keyName])
            resultArr.push(arr[i])
        }
    }
    return resultArr
}

/**
 * 一键复制
 * content 复制的内容
 */
export function copy(content, notShowTips = false) {
    //创建input标签
    let input = document.createElement('input')
        //将input的值设置为需要复制的内容
    input.value = content;
    //添加input标签
    document.body.appendChild(input)
        //选中input标签
    input.select()
        //执行复制
    document.execCommand('copy')
        //成功提示信息
    if (!notShowTips) Message.success('复制成功!')
        //移除input标签
    document.body.removeChild(input)
}

//将key值相同的数据合并
export function mergeSimilarItems(arr, key) {
    return arr.reduce((acc, current) => {
        const x = acc.find(item => item[key] === current[key]);
        if (x) {
            // 如果已存在，则合并
            x.value = (x.value || 0) + (current.value || 0);
        } else {
            // 如果不存在，则添加到结果数组
            acc.push(current);
        }
        return acc;
    }, []);
};
/**
 * js截取两个字之间的内容
 * @param {*} str 需要截取的内容
 * @param {*} start 开始的字符
 * @param {*} end 结束的字符
 * @returns 返回值
 */
export function getContentBetween(str, start, end) {
    const regex = new RegExp(start + '(.*?)' + end, 's'); // 's' 修饰符允许 . 匹配换行符
    const match = str.match(regex);
    return match ? match[1] : '';
}
/**
 * 获取span标签之前的内容
 * @param {*} str 
 * @param {*} index 
 * @returns 
 */
export function getSpanData(str, index) {
    // 使用正则表达式匹配<span>标签中的内容
    const regex = /<span[^>]*>(.*?)<\/span>/g;
    let match;
    let results = [];

    // 循环查找所有匹配项
    while ((match = regex.exec(str)) !== null) {
        // 如果提供了索引，只添加指定索引的数据
        if (index !== undefined && results.length === index) {
            results.push(match[1]); // match[1] 是捕获组中的数据
        } else if (index === undefined) {
            results.push(match[1]);
        }
    }
    // 如果没有指定索引，返回所有匹配的数据；否则返回指定索引的数据
    return index !== undefined ? results[0] : results;
}

//判断是否在某断时间内
export function isWithinTimeRange(startHour, startMinute, endHour, endMinute) {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  // 将当前时间转换为分钟数
  const currentTimeInMinutes = currentHour * 60 + currentMinute;

  // 将开始时间和结束时间转换为分钟数
  const startTimeInMinutes = startHour * 60 + startMinute;
  const endTimeInMinutes = endHour * 60 + endMinute;

  // 判断当前时间是否在指定的时间范围内
  if (startTimeInMinutes <= endTimeInMinutes) {
    return currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes < endTimeInMinutes;
  } else {
    // 处理跨天的情况
    return currentTimeInMinutes >= startTimeInMinutes || currentTimeInMinutes < endTimeInMinutes;
  }
}

//解析 URL参数
export function getQueryParams(url) {
  const params = {};
  const queryString = url.split('?')[1]; // 获取 ? 后的部分

  if (queryString) {
    queryString.split('&').forEach(pair => {
      const [key, value] = pair.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    });
  }

  return params;
}